import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const StyledLink = styled(Link)`
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: ${({ active }) => (!active ? "none" : "")};
`

const StyledHref = styled.a`
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: ${({ active }) => (!active ? "none" : "")};
`

export const SliderLink = ({ active, link, children }) => {
  return (
    <>
      {link.href ? (
        <StyledHref
          active={active ? 1 : 0}
          href={link.href}
          target="_blank"
          title={link.title}
        >
          {children}
        </StyledHref>
      ) : (
        <StyledLink swipe direction="up" active={active ? 1 : 0} to={link.slug}>
          {children}
        </StyledLink>
      )}
    </>
  )
}
